import React from 'react';
import { component } from 'picoapp';
import { render } from 'react-dom';
import ProductGallery from './ProductGallery';
import ProductSpecsGallery from './ProductSpecsGallery';
import { QueryClient, QueryClientProvider } from 'react-query';

export default component((node, ctx) => {
  if (!customElements.get('product-gallery')) {
    customElements.define(
      'product-gallery',
      class extends HTMLElement {
        connectedCallback() {
          const props = Object.values(this.attributes).map((attribute) => [attribute.name, attribute.value]);
          render(
            <QueryClientProvider client={new QueryClient()}>
              <ProductGallery {...Object.fromEntries(props)} />
            </QueryClientProvider>,
            this
          );
        }
      }
    );
  }
  if (!customElements.get('product-specs-gallery')) {
    customElements.define(
      'product-specs-gallery',
      class extends HTMLElement {
        connectedCallback() {
          const props = Object.values(this.attributes).map((attribute) => [attribute.name, attribute.value]);
          render(
            <QueryClientProvider client={new QueryClient()}>
              <ProductSpecsGallery {...Object.fromEntries(props)} />
            </QueryClientProvider>,
            this
          );
        }
      }
    );
  }
});
